var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "correct",
    transform: "translate(0.000000, 0.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50,0 C22.421875,0 0,22.421875 0,50 C0,77.578125 22.421875,100 50,100 C77.578125,100 100,77.578125 100,50 C100,22.421875 77.578125,0 50,0 Z",
    id: "Path",
    fill: "#76B82A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1796875,33.1445312 C75.390625,34.3554687 75.390625,36.3476562 74.1796875,37.5585938 L44.8828125,66.8554687 C44.2773438,67.4609375 43.4765625,67.7734375 42.6757812,67.7734375 C41.875,67.7734375 41.0742188,67.4609375 40.46875,66.8554687 L25.8203125,52.2070312 C24.609375,50.9960937 24.609375,49.0039062 25.8203125,47.7929687 C27.03125,46.5820312 29.0234375,46.5820312 30.234375,47.7929687 L42.6757812,60.234375 L69.765625,33.1445312 C70.9765625,31.9140625 72.96875,31.9140625 74.1796875,33.1445312 Z",
    id: "Path",
    fill: "#FFFFFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.fec459e9443654c2c2c97421b081e13d.svg";
export { ForwardRef as ReactComponent };